import Vue from 'vue'
import VueRouter from 'vue-router'

import Dashboard from '@/components/dashboard'
import NotFound from '@/components/NotFound'
import Login from '@/components/auth/Login'
import Forgot from '@/components/auth/Forgot'

import Jobs from './components/jobs/index.vue'
import Job from './components/jobs/Job.vue'

import Notes from './components/notes/index.vue'
import Note from './components/notes/Note.vue'



import Quotes from './components/quotes/index.vue'
import Quote from './components/quotes/Quote.vue'

import Orders from './components/orders/index.vue'
import Order from './components/orders/Order.vue'

import Invoices from './components/invoices/index.vue'
import Invoice from './components/invoices/Invoice.vue'

import Time from './components/time/index.vue'

import Settings from './components/settings/index.vue'
import SettingCompany from './components/settings/CompanyDetails'
import SettingTeam from './components/settings/Team'
import SettingUserTypes from '@/components/settings/UserTypes'
import SettingCostCategories from '@/components/settings/CostCategories'
import SettingCostMatrix from '@/components/settings/CostMatrix'
import SettingClientUsers from '@/components/settings/ClientUsers'
import SettingXero from '@/components/settings/Xero'
//import SettingDepartments from '@/components/settings/Departments'
import EmailTemplates from '@/components/settings/EmailTemplates/index.vue'
import EmailTemplate from '@/components/settings/EmailTemplates/EmailTemplate.vue'

import Clients from './components/clients/index.vue'
import Client from './components/clients/Client.vue'

import Account from './components/account/index.vue'
import AccountProfile from './components/account/Profile.vue'
import AccountNotifications from './components/account/AccountNotifications.vue'
import ClientMemberNotifications from './components/account/ClientMemberNotifications.vue'
import RequestNotifications from './components/account/RequestNotifications.vue'

import store from './store';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/', name: 'dashboard', component: Dashboard,
    },
    {
      path: '/login', name: 'login', component: Login,
    },
    {
      path: '/forgot', name: 'forgot', component: Forgot,
    },
    {
      path: '/not-found', name: 'not-found', component: NotFound,
    },
    {
      path: '/jobs', name: 'jobs', component: Jobs,
    },
    {
      path: '/job/:jobId', name: 'job', component: Job, props: true
    },
    {
      path: '/notes', name: 'notes', component: Notes,
    },
    {
      path: '/notes/:noteId', name: 'note', component: Note, props: true
    },
    {
      path: '/clients', name: 'clients', component: Clients,
    },
    {
      path: '/clients/:itemId', name: 'client', component: Client, props: true,
    },
    {
      path: '/clients/:itemId/:tab', name: 'client-tab', component: Client, props: true,
    },
    {
      path: '/suppliers', name: 'suppliers', component: Clients,
    },
    {
      path: '/suppliers/:itemId', name: 'supplier', component: Client, props: true,
    },
    {
      path: '/suppliers/:itemId/:tab', name: 'supplier-tab', component: Client, props: true,
    },
    {
      path: '/quotes', name: 'quotes', component: Quotes,
    },
    {
      path: '/quotes/:quoteId', name: 'quote', component: Quote, props: true
    },
    {
      path: '/orders', name: 'orders', component: Orders,
    },
    {
      path: '/orders/:orderId', name: 'order', component: Order, props: true
    },
    {
      path: '/invoices', name: 'invoices', component: Invoices,
    },
    {
      path: '/invoices/:invoiceId', name: 'invoice', component: Invoice, props: true
    },
    {
      path: '/time', name: 'time', component: Time,
    },
    {
      path: '/settings', component: Settings,
      children: [
        {
          path: '', name: 'settings',
          component: SettingCompany,
        },
        {
          path: 'team', name: 'settings-team',
          component: SettingTeam,
        },
        {
          path: 'user-types', name: 'settings-user-types',
          component: SettingUserTypes
        },
        {
          path: 'cost-categories', name: 'settings-cost-categories',
          component: SettingCostCategories
        },
        {
          path: 'cost-matrix', name: 'settings-cost-matrix',
          component: SettingCostMatrix
        },
        {
          path: 'client-users', name: 'settings-client-users',
          component: SettingClientUsers
        },
        {
          path: 'xero', name: 'settings-xero',
          component: SettingXero
        },
        {
          path: 'email-templates', name: 'settings-email-templates',
          component: EmailTemplates,
        },
        {
          path: 'email-templates/:templateId', name: 'settings-email-template',
          component: EmailTemplate, props: true
        },
        /*
        {
          path: 'departments', name: 'setting-departments',
          component: SettingDepartments
        }
        */
      ]
    },
    {
      path: '/account', component: Account,
      children: [
        {
          path: '', name: 'account',
          component: AccountProfile,
        },
        {
          path: 'notifications', name: 'account-notifications',
          component: AccountNotifications,
        },
        {
          path: 'notifications', name: 'notifications',
          component: ClientMemberNotifications,
        },
        {
          path: 'job-requests', name: 'job-requests',
          component: RequestNotifications,
        }
      ]
    },
    {
      path: '/*', redirect: { name: 'not-found' }
    },
  ]
});

router.beforeEach((to, from, next) => {
  let user_type_id = store.state.option.currentUser && typeof store.state.option.currentUser.user_type_id != "undefined" ? store.state.option.currentUser.user_type_id : '';
  if (!user_type_id && typeof localStorage != "undefined") {
    user_type_id = parseInt(localStorage.getItem('user_type_id'));
  }
  let is_super_admin = user_type_id == 1;
  let admin_path_names = ['notes', 'note', 'clients', 'client', 'suppliers', 'supplier', 'quotes', 'quote', 'orders', 'order', 'invoices', 'invoice', 'settings', 'job-requests'];
  if (!is_super_admin && (admin_path_names.indexOf(to.name) != -1 || to.fullPath.indexOf('/settings') != -1)) {
    next('/not-found');
  }
  next();
});


export default router;
